import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { OneTrustInstance } from './one-trust-instance';
import { OneTrustLoaderService } from './onetrust-loader.service';

@Injectable()
export class OneTrustService {
  private oneTrust!: OneTrustInstance;

  constructor(
    loader: OneTrustLoaderService,
    @Inject(DOCUMENT) document: Document
  ) {
    this.oneTrust = new OneTrustInstance(
      loader,
      document.defaultView as Window
    );
  }

  initializeCookiePolicyHtml() {
    this.oneTrust.initializeCookiePolicyHtml().subscribe();
  }

  toggleInfoDisplay() {
    this.oneTrust.toggleInfoDisplay().subscribe();
  }
}
